import { useDashboardFeatureFlags } from '@components/utils/DashboardFeatureFlags'
import { useCurrentTheme } from '@modules/ThemeEditorV2'

export const useCurrencySettings = () => {
  const { currentTheme } = useCurrentTheme()
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()
  const yenEnabled =
    dashboardFeatureFlags.multicurrencyCustomThemeYen.enabled ||
    currentTheme?.customisation !== 'Fully'

  const currencyList = [
    {
      currency: 'USD' as const,
      flag: 'US',
      disabled: true,
      tooltip: 'USD is a base currency and cannot be disabled',
    },
    { currency: 'EUR' as const, flag: 'EU' },
    { currency: 'CAD' as const, flag: 'CA' },
    { currency: 'GBP' as const, flag: 'GB' },
    { currency: 'AUD' as const, flag: 'AU' },
    { currency: 'NZD' as const, flag: 'NZ' },
    { currency: 'BRL' as const, flag: 'BR' },
    { currency: 'MXN' as const, flag: 'MX' },
    { currency: 'SEK' as const, flag: 'SE' },
    { currency: 'NOK' as const, flag: 'NO' },
    { currency: 'DKK' as const, flag: 'DK' },
    { currency: 'PLN' as const, flag: 'PL' },
    { currency: 'JPY' as const, flag: 'JP', disabled: !yenEnabled },
    { currency: 'MYR' as const, flag: 'MY' },
    { currency: 'SGD' as const, flag: 'SG' },
  ]

  return {
    currencySettings: {
      list: currencyList,
      enabled:
        dashboardFeatureFlags.multicurrencyCustomTheme.enabled ||
        currentTheme?.customisation !== 'Fully',
      yenEnabled,
    },
  }
}
